import React from 'react'
import DataTable from '../../DataTable/DataTable'
import clsx from "clsx"

export default class OrderCardBuilderHistory extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'history',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="history">
        <div className="row">
          <div className="col-md-12">
          {
          !this.props.new_record
          ?
          <DataTable
            endpoint={this.props.order_revision_history_path}
            no_data_text={I18n.t('none')}
            date_format={this.props.date_format}
            time_format={this.props.time_format} 
            model_name={"Order"}/>
          :
          null}
          </div>
        </div>
      </div>  
    );
  };
};